import React, { useEffect, useState } from "react";
import { Row, Col, Card, CardBody, Button, Input, FormGroup, Label } from "reactstrap";
import Breadcrumbs from "../../../components/Common/Breadcrumb";
import Models from './model.json';
import "../tables.scss";
import "../Puestos.scss";
import { httpGet, httpPost, httpPUT, httpUpload } from "../../../../src/common/petitions";
import Dropzone from "react-dropzone";
import DataLoader from "../../../components/tableData";
import { useNavigate } from 'react-router-dom';
import Select from 'react-select';
import useUpdateCreateAlert from '../../../components/alerts';

export const IngresoMOI = () => {
  const [status, setStatus] = useState(null);
  const [message, setMessage] = useState('');
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isUpdate, setIsUpdate] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [periodo, setPeriodo] = useState('20242025');
  const [ccu, setCcu] = useState('');
  const [puesto, setPuesto] = useState('');
  const [ordinario, setOrdinario] = useState('');
  const [cantidad, setCantidad] = useState('');
  const navigate = useNavigate();
  const [cculist, setCculist] = useState([]);
  const [positionList, setPositionList] = useState([]);
  const [totalGlobal, setTotalGlobal] = useState(0);

  
  const [uploadResult, setUploadResult] = useState(null);
  
  const [isUploading, setIsUploading] = useState(false);

  useUpdateCreateAlert(status, message);
  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    setIsLoading(true);
    try {
      const rowsData = await httpGet(`/moi/20232024`, navigate);
      console.log(rowsData);
      const jsonData = { columns: Models.ccu, rows: rowsData.data };
      // setCculist(rowsData.cculist);
      // setPositionList(rowsData.positionList);
      setData(jsonData);
      setTotalGlobal(rowsData.totals);
      console.log(rowsData.totals.total);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
    setIsLoading(false);
  };

  const handleSelectChange = (selectedOption, action) => {
    const { name } = action;
    const value = selectedOption ? selectedOption.value : '';

    if (name === 'ccu') setCcu(value);
    if (name === 'puesto') setPuesto(value);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    if (name === 'ordinario') setOrdinario(value);
    if (name === 'cantidad') setCantidad(value);
  };

  const validateInputs = () => {
    if (!ccu || !puesto || !ordinario || !cantidad) {
      setMessage('Complete todos los datos por favor');
      setStatus('error');
      return false;
    }
    if (isNaN(ordinario) || isNaN(cantidad)) {
      setMessage('Ordinario y cantidad deben ser numeros');
      setStatus('error');
      return false;
    }
    return true;
  };
  const handleSubmit = async () => {
    if (!validateInputs()) return;
    // console.log({ periodo, ccu, puesto, ordinario: parseFloat(ordinario), cantidad });
    try {
      if (isUpdate) {
        await httpPUT(`/moi/${selectedItem.idunique}`, { periodo, ccu, puesto, ordinario: parseFloat(ordinario), cantidad }, navigate);
        setMessage('Actualizado correctamente');
        setStatus('Actualizacion');
      } else {
        await httpPost(`/moi`, { periodo, ccu, puesto, ordinario: parseFloat(ordinario), cantidad }, navigate);
        setMessage('Creado correctamente');
        setStatus('Nuevo');
      }
      fetchData();
      handleReset();
    } catch (error) {
      console.error("Error submitting data:", error);
    }
  };

  const downloadTemplate = async () => {
    try {
      const response = await fetch("/templates_xls/PRESUPUESTOMAQ_MOI.xlsx");
      const blob = await response.blob();
      const url = window.URL.createObjectURL(new Blob([blob]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "PRESUPUESTOMAQ_MOI.xlsx");
      document.body.appendChild(link);
      link.click();
      link.parentNode.removeChild(link);
    } catch (error) {
      console.error("Error downloading template:", error);
    }
  };
  const uploadFile = async (file) => {
    setIsUploading(true);
    const formdata = new FormData();
    formdata.append("file", file);
    // console.log(file);
    try {
      const response = await httpUpload(`/moi/import`,formdata,navigate);
      setUploadResult(response);
    } catch (error) {
      alert(error.message);
      console.error("Error uploading file:", error);
    }finally {
      setIsUploading(false);
    }
  };

  const handleAcceptedFiles = (files) => {
    const file = files[0];
    uploadFile(file);
  };

  const handleEdit = (item) => {
    setSelectedItem(item);
    setCcu({ value: item.ccu, label: item.ccu });
    setPuesto({ value: item.puesto, label: item.puesto });
    setOrdinario(item.ordinario);
    setCantidad(item.cantidad);
    setIsUpdate(true);
  };

  const handleDelete = async (id) => {
    if (window.confirm("Are you sure you want to delete this item?")) {
      try {
        await httpDelete(`/moi/${id}`, navigate);
        fetchData();
      } catch (error) {
        console.error("Error deleting item:", error);
      }
    }
  };

  const handleReset = () => {
    setSelectedItem(null);
    setPeriodo('20242025');
    setCcu(null);
    setPuesto(null);
    setOrdinario('');
    setCantidad('');
    setIsUpdate(false);
  };

  document.title = "MOI - Management";
  return (
    <React.Fragment>
      <div className="page-content">
        <div className="container-fluid">
          <Breadcrumbs maintitle="Mano de obra indirecta" title="Ingreso" />

          <Row>
          <Col className="col-12">
              <Card>
                <CardBody>
                    <Dropzone onDrop={handleAcceptedFiles}>
                      {({ getRootProps, getInputProps }) => (
                        <div className="dropzone-container">
                          <div className="btn btn-success dropzone  me-5 " {...getRootProps()}>
                            <input {...getInputProps()} />
                            <span>Subir mano de obra indirecta</span>
                          </div>
                          {isUploading && <div className="upload-loader">Uploading...</div>}
                          {uploadResult && (
                            <div className="upload-check">
                              <i className="bx bx-check-circle"></i>
                            </div>
                          )}
                        </div>
                      )}
                    </Dropzone>

                <Button color="light" className="mi-5" onClick={downloadTemplate}>
                  <i className="bx bx-download me-1"></i> Descargar Plantilla (.xlsx)
                </Button>
                </CardBody>
              </Card>
            </Col>
            {/* <Col className="col-12">
              <Card>
                <CardBody>
                  <h4>{isUpdate ? 'Modificar' : 'Agregar'}</h4>
                  <Row>
                    <Col className="col-6">
                      <FormGroup>
                        <Label for="ccu">CCU</Label>
                        <Select
                          options={cculist}
                          onChange={(option, action) => handleSelectChange(option, action)}
                          name='ccu'
                        />
                      </FormGroup>
                    </Col>
                    <Col className="col-6">
                      <FormGroup>
                        <Label for="puesto">Puesto</Label>
                        <Select
                          options={positionList}
                          onChange={(option, action) => handleSelectChange(option, action)}
                          name='puesto'
                        />
                      </FormGroup>
                    </Col>
                    <Col className="col-6">
                      <FormGroup>
                        <Label for="ordinario">Ordinario</Label>
                        <Input type="number" name="ordinario" id="ordinario" value={ordinario} onChange={handleInputChange} />
                      </FormGroup>
                    </Col>
                    <Col className="col-6">
                      <FormGroup>
                        <Label for="cantidad">Cantidad</Label>
                        <Input type="number" name="cantidad" id="cantidad" value={cantidad} onChange={handleInputChange} />
                      </FormGroup>
                    </Col>
                  </Row>
                  <Button color="primary" onClick={handleSubmit}>{isUpdate ? 'Actualizar' : 'Agregar'}</Button>
                </CardBody>
              </Card>
            </Col> */}
          </Row>

          <Row>
            <Col className="col-12">
            <h1>
                    TOTAL:{totalGlobal}
                  </h1>
              <Card>
                <CardBody>
                  
                 {isLoading ? (
                    <p>Loading...</p>
                  ) : (
                    data && <DataLoader data={data}  />
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
      </div>
    </React.Fragment>
  );
};
